import { render, staticRenderFns } from "./ListItemDisease.vue?vue&type=template&id=9a0891b8&"
import script from "./ListItemDisease.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemDisease.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a0891b8')) {
      api.createRecord('9a0891b8', component.options)
    } else {
      api.reload('9a0891b8', component.options)
    }
    module.hot.accept("./ListItemDisease.vue?vue&type=template&id=9a0891b8&", function () {
      api.rerender('9a0891b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemDisease/ListItemDisease.vue"
export default component.exports